import { Caption2, makeStyles } from '@fluentui/react-components';
import { EditRegular } from '@fluentui/react-icons';

import { DateLabel } from '@shared/components';

type TProps = {
  createdDate: string;
  editedDate?: string;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '.25rem',
    justifyContent: 'space-between',
    width: 'fit-content',
  },
});

const DateTimeLabel = ({ createdDate, editedDate }: TProps) => {
  // If the comment was edited, we replace the create date with an edit icon & date
  const showEdited = !!editedDate;
  const displayedDate = showEdited ? editedDate : createdDate;

  const classnames = useStyles();

  return (
    <Caption2 as="p" className={classnames.container}>
      {showEdited && <EditRegular />}
      <DateLabel withTime>{displayedDate}</DateLabel>
    </Caption2>
  );
};

export default DateTimeLabel;
